import { useMatch } from "react-router";

const DefaultTabParamName = "tab";

/**
 * Resolves which value of `tabs` the given route `pattern` currently matched: the shape shared by
 * every "which tab is active" hook in the app — match the route, then find the enum value equal to
 * the matched tab segment. `paramName` names that segment for patterns that call it something other
 * than `:tab`. Returns undefined when nothing matched or the segment isn't a known tab.
 */
export function useActiveTabFromMatch<TTab extends string>(
  pattern: string,
  tabs: Record<string, TTab>,
  paramName: string = DefaultTabParamName
): TTab | undefined {
  const match = useMatch(pattern);
  const segment = match?.params[paramName];
  return Object.values(tabs).find((tab) => tab === segment);
}
